import { createSlice } from "@reduxjs/toolkit"
const slice = createSlice({
    name:'UI',
    initialState:{},
    reducers:{
        ChangeProductGridDisplay:(state,action)=>{
            state.productGridDisplay = action.payload
        }
    }

})
export default slice.reducer;
export const {ChangeProductGridDisplay} = slice.actions